<div class="dialog-content-wrapper p-24">
    <h3 *ngIf="!noticia" mat-dialog-title>Cadastrar Notícia</h3>
    <h3 *ngIf="noticia" mat-dialog-title>Alterar Notícia</h3>
    <div mat-dialog-content class="py-24 px-0 m-0" fusePerfectScrollbar [formGroup]="formGroupCadastro">
        <div fxLayout="row wrap" fxLayoutAlign="start center">

            <div fxFlex.gt-sm="100%" appearance="outline" fxFlex="100">
                <mat-form-field style="width: 50%" appearance="outline" fxFlex="100" floatLabel="always">
                    <mat-label>Título</mat-label>
                    <input matInput placeholder="Título" [formControl]="titulo" required [maxlength]="100">
                    <mat-error *ngIf="titulo.invalid">{{getErrorTituloMessage()}}</mat-error>
                </mat-form-field>
            </div>

            <div fxFlex.gt-sm="100%">
                <mat-form-field appearance="outline" fxFlex="100" floatLabel="always">
                    <mat-label>Categoria</mat-label>
                    <mat-select [formControl]="categoria_id" name="categoria_id" required>
                        <mat-option value="">SELECIONE</mat-option>
                        <mat-option *ngFor="let categoria of listCategorias" [value]="categoria.id">{{categoria.nome}}
                        </mat-option>
                    </mat-select>
                    <mat-spinner diameter="20" *ngIf="loadingSpinnerCategoria"></mat-spinner>
                    <mat-error *ngIf="categoria_id.invalid">{{getErrorCategoriaMessage()}}</mat-error>
                </mat-form-field>
            </div>


            <div fxFlex.gt-sm="100%" appearance="fill" fxFlex="100">
                <quill-editor #editor class="content-editor" [placeholder]="''" [modules]="quillConfiguration"
                    [styles]="{'min-height': '120px'}" formControlName="editor" [(ngModel)]="initialText"> </quill-editor>
            </div>

            <div *ngIf="midia && midia.id && !midia.deleted" fxFlex.gt-sm="100%" appearance="fill" fxFlex="100">
                <div  [ngSwitch]="midia.tipoMidia" class="midia-preview mt-4 mb-4" fxFlex="1 1 auto">
                    <div *ngSwitchCase="tipoMidiaEnum.Imagem" class="preview-image">
                        <app-secured-image [src]="getUrlMidia()" [alt]="noticia.titulo" [imgClass]="'secured-image-preview'">
                        </app-secured-image>
                    </div>
                
                    <div *ngSwitchCase="tipoMidiaEnum.Video" class="preview-image">
                        <app-secured-image [src]="getUrlThumbnail()" [alt]="noticia.titulo" [imgClass]="'secured-image-preview'"></app-secured-image>
                    </div>
                
                    <div *ngSwitchCase="tipoMidiaEnum.Download" class="preview-image">
                        <mat-icon aria-hidden="false" aria-label="Anexo">attachment</mat-icon>
                    </div>

                    <button mat-icon-button (click)="prepareToDeleteMidia()" aria-label="Close dialog">
                        <mat-icon>close</mat-icon>Apagar Mídia
                    </button>
                </div>
            </div>


            <input 
                hidden 
                type="file" 
                #fileInput 
                (change)="uploadFile($event)" 
                ng2FileSelect 
                [uploader]="uploader"
                [accept]="formatsAccepts" 
            />
            <button mat-button (click)="fileInput.click()" tabindex="-1" [disabled]="uploader.queue.length > 0 || (midia && midia.id != '' && !midia.deleted)">
                <mat-icon>cloud_upload</mat-icon>
                Anexar
            </button>

            <p *ngFor="let item of uploader.queue">
                <b>{{nomeFile}}</b>
                <button type="button" mat-button tabindex="-1" (click)="item.remove()">
                    X
                </button>
            </p>
        </div>

        <div mat-dialog-actions>
            <button mat-button tabindex="2" (click)="onNoClick()">
                Cancelar
            </button>
            <button mat-button *ngIf="!noticia"[disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1" >
                Criar
            </button>
            <button mat-button *ngIf="noticia" [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">
                Alterar
            </button>
        </div>
    </div>  
</div>